import { render, staticRenderFns } from "./ErrorGroup.vue?vue&type=template&id=6d7df66b&"
import script from "./ErrorGroup.vue?vue&type=script&lang=ts&"
export * from "./ErrorGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports